import { useRecoilValue } from "recoil";
import { parentCompaniesAtom } from "../miscellaneous/parentCompaniesAtom";

export const useParentCompaniesValue = () => {
  return useRecoilValue(parentCompaniesAtom);
};
